const initialState = {
  loading: false,
  data: null,
  error: null,
};

const usersReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_FREE_VOTE_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "FETCH_FREE_VOTE_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case "FETCH_FREE_VOTE_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default usersReducer;
